<template>
    <span 
        :title="props.agesLine.src">
        {{props.agesLine.since}} – {{till}}
    </span>
</template>

<script setup>
import {computed} from 'vue'
const props = defineProps({
    agesLine : Object,
})

const till = computed(() => {
    let t = props.agesLine.till

    return  `${t-1}.99`
})


</script>